import { lazy } from "react";

import AppIcons from "../../../components/Base/AppIcons";
import { dictPermissionsModuleReportes } from "./listPermissionsModuleReportes";

const ViewsReportesMov = lazy(() => import("./views/ViewsReportesMov"));
const ViewsReportesDev = lazy(() => import("./views/ViewsReportesDev"));

export const ListRoutesModuleReportes = [
  {
    link: "/pasarela-asignacion-qr--reportes-movimientos",
    label: (
      <AppIcons Logo={"RECAUDO"} name="Reporte Movimientos Asignación Por QR" />
    ),
    component: ViewsReportesMov,
    permission: [dictPermissionsModuleReportes.reportes_mov],
    subRoutes: [],
    show: true,
  },
  {
    link: "/pasarela-asignacion-qr--reportes--devoluciones",
    label: (
      <AppIcons
        Logo={"RECAUDO"}
        name="Reporte Devoluciones Asignación Por QR"
      />
    ),
    component: ViewsReportesDev,
    permission: [dictPermissionsModuleReportes.reportes_dev],
    subRoutes: [],
    show: true,
  },
];
